import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PasswordResetFinishedComponent } from './landing/password-reset-finished/password-reset-finished.component';
import { AccountIntegrationComponent } from './pages/account-integration/account-integration.component';
import { Auth0ErrorComponent } from './pages/auth0-error/auth0-error.component';
import { AuthorizeComponent } from './pages/authorize/authorize.component';
import { DoctorsNextComponent } from './pages/doctors-next/doctors-next.component';
import { LoginConfirmComponent } from './pages/login-confirm/login-confirm.component';
import { LoginGuideComponent } from './pages/login-guide/login-guide.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { TestComponent } from './pages/test/test.component';
import { UnblockComponent } from './pages/unblock/unblock.component';
import { UpdatedPasswordComponent } from './pages/updated-password/updated-password.component';
import { VerifyComponent } from './pages/verify/verify.component';
import { VerifyEmailComponent } from './shared/pages/errors/verify-email/verify-email.component';
import { LandingComponent } from './shared/pages/landing/landing.component';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'authorize', component: AuthorizeComponent },
  // ログイン関連のルーティングを一括追加
  { path: 'redirect/authorize', component: RedirectComponent },
  ...[
    'login',
    'register',
    'forgot-password',
    'password-reset-send',
    'register-resend',
  ].map((path) => {
    return { path, component: AuthorizeComponent, data: { page: path } };
  }),
  // パスワード変更完了画面. https://doctors-jp.backlog.com/view/CBPT-4671
  { path: 'updated-password', component: UpdatedPasswordComponent },
  // verify email
  { path: 'register-send', component: VerifyEmailComponent },
  {
    path: 'login',
    children: [
      { path: 'doctors-next/authorize', component: DoctorsNextComponent },
      { path: 'test/authorize', component: TestComponent },
      { path: 'confirm', component: LoginConfirmComponent },
    ],
  },
  { path: 'verify/:client_id', component: VerifyComponent },
  {
    path: 'password-reset-finished/:client_id',
    component: PasswordResetFinishedComponent,
  },
  { path: 'unblock/:client_id', component: UnblockComponent },
  { path: 'lo/reset', component: ResetPasswordComponent },
  // ログイン案内ページ
  { path: 'login-guide', component: LoginGuideComponent },
  // アカウント連携ページ
  { path: 'account-integration', component: AccountIntegrationComponent },
  // Auth0からのエラー画面
  { path: 'error', component: Auth0ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
